import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-6 mb-8 bg-white rounded-lg lg:p-8" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "mb-6 text-xl font-bold text-primary-500" }, "II. For Company Health Check-Up", -1)
const _hoisted_3 = { class: "grid grid-cols-1 lg:grid-cols-12 gap-x-8 gap-y-6" }
const _hoisted_4 = { class: "col-span-full lg:col-span-6" }
const _hoisted_5 = { class: "col-span-full lg:col-span-6" }
const _hoisted_6 = { class: "col-span-full lg:col-span-6" }
const _hoisted_7 = { class: "col-span-full lg:col-span-6" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "mb-5 mt-8 border-b border-black/[.04]" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "mb-4 font-bold text-darkgray-800" }, "Job Category / 職種", -1)
const _hoisted_10 = { class: "grid grid-cols-1 lg:grid-cols-12 gap-x-8 gap-y-6" }
const _hoisted_11 = { class: "col-span-full lg:col-span-6" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "ml-2" }, [
  /*#__PURE__*/_createElementVNode("label", {
    for: "rank_and_file",
    class: "block leading-5 text-darkgray-400"
  }, " Rank and File / 一般社員 ")
], -1)
const _hoisted_13 = { class: "col-span-full lg:col-span-6" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "ml-2" }, [
  /*#__PURE__*/_createElementVNode("label", {
    for: "supervisory",
    class: "block leading-5 text-darkgray-400"
  }, " Supervisory / 主任 ")
], -1)
const _hoisted_15 = { class: "col-span-full lg:col-span-6" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "ml-2" }, [
  /*#__PURE__*/_createElementVNode("label", {
    for: "managerial",
    class: "block leading-5 text-darkgray-400"
  }, " Managerial / 管理職 ")
], -1)
const _hoisted_17 = { class: "col-span-full lg:col-span-6" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "ml-2" }, [
  /*#__PURE__*/_createElementVNode("label", {
    for: "top_management",
    class: "block leading-5 text-darkgray-400"
  }, " Top Management / 経営者 ")
], -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "mb-5 mt-8 border-b border-black/[.04]" }, null, -1)
const _hoisted_20 = { class: "grid grid-cols-1 mb-10 lg:grid-cols-12 gap-x-8 gap-y-6" }
const _hoisted_21 = { class: "col-span-full" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("p", { class: "mb-2 font-bold" }, "Please check the following option for test results / 結果表の受け取り方について、以下のオプションをご確認ください。", -1)
const _hoisted_23 = { class: "grid grid-cols-1 space-y-2 lg:grid-cols-12" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-6" }, null, -1)
const _hoisted_25 = { class: "col-span-6 mt-3 pl-7" }

import TextInput from '@/components/inputs/TextInput.vue';
import CheckboxInput from '@/components/inputs/CheckboxInput.vue';
import RadioGroup from '@/components/inputs/RadioGroup.vue';
import patient from "@/classes/UserData";
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CompanyInformation',
  props: {
    form: {
        type: Object,
        required: true
    },
    errors: {
        type: Array,
        required: true
    },
    disableInputs: {
        type: Boolean,
        default: false
    }
},
  setup(__props) {

const props = __props

const gender = patient.getGender()
const item = ref(props.form)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(TextInput, {
          id: "company_name",
          disabled: __props.disableInputs,
          modelValue: item.value.company_name,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((item.value.company_name) = $event)),
          type: "text",
          placeholder: "Company Name / 会社名"
        }, null, 8, ["disabled", "modelValue"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(TextInput, {
          id: "company_no",
          disabled: __props.disableInputs,
          modelValue: item.value.company_no,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((item.value.company_no) = $event)),
          type: "text",
          placeholder: "Company No. / 会社番号 :"
        }, null, 8, ["disabled", "modelValue"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(TextInput, {
          id: "hmo_name",
          disabled: __props.disableInputs,
          modelValue: item.value.hmo_name,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((item.value.hmo_name) = $event)),
          type: "text",
          placeholder: "HMO Name / 保険会社名"
        }, null, 8, ["disabled", "modelValue"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(TextInput, {
          id: "hmo_no",
          disabled: __props.disableInputs,
          modelValue: item.value.hmo_no,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((item.value.hmo_no) = $event)),
          type: "text",
          placeholder: "HMO No. / 保険番号 :"
        }, null, 8, ["disabled", "modelValue"])
      ])
    ]),
    _hoisted_8,
    _hoisted_9,
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createVNode(CheckboxInput, {
          id: "rank_and_file",
          modelValue: item.value.rank_and_file,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((item.value.rank_and_file) = $event)),
          "default-slot": false,
          rounded: false,
          "is-checked": item.value.rank_and_file
        }, {
          default: _withCtx(() => [
            _hoisted_12
          ]),
          _: 1
        }, 8, ["modelValue", "is-checked"])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createVNode(CheckboxInput, {
          id: "supervisory",
          modelValue: item.value.supervisory,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((item.value.supervisory) = $event)),
          "default-slot": false,
          rounded: false,
          "is-checked": item.value.supervisory
        }, {
          default: _withCtx(() => [
            _hoisted_14
          ]),
          _: 1
        }, 8, ["modelValue", "is-checked"])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createVNode(CheckboxInput, {
          id: "managerial",
          modelValue: item.value.managerial,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((item.value.managerial) = $event)),
          "default-slot": false,
          rounded: false,
          "is-checked": item.value.managerial
        }, {
          default: _withCtx(() => [
            _hoisted_16
          ]),
          _: 1
        }, 8, ["modelValue", "is-checked"])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createVNode(CheckboxInput, {
          id: "top_management",
          modelValue: item.value.top_management,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((item.value.top_management) = $event)),
          "default-slot": false,
          rounded: false,
          "is-checked": item.value.top_management
        }, {
          default: _withCtx(() => [
            _hoisted_18
          ]),
          _: 1
        }, 8, ["modelValue", "is-checked"])
      ])
    ]),
    _hoisted_19,
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("div", _hoisted_21, [
        _hoisted_22,
        _createElementVNode("div", _hoisted_23, [
          _createVNode(RadioGroup, {
            options: [
                            { id: 'pick_up', label: 'Pick-up/来院', value: 'pick_up'},
                            { id: 'same_as_above', label: 'Same as above/同上', value: 'same_as_above'},
                            { id: 'delivery', label: 'Delivery/配送', value: 'delivery'},
                            { id: 'others', label: 'Others/別の住所', value: 'others'},
                        ],
            name: "test_result_option",
            customClass: "col-span-6",
            modelValue: item.value.test_result_option,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((item.value.test_result_option) = $event))
          }, null, 8, ["modelValue"]),
          _hoisted_24,
          _createElementVNode("div", _hoisted_25, [
            (item.value.test_result_option == 'others')
              ? (_openBlock(), _createBlock(TextInput, {
                  key: 0,
                  id: "specify_others_option",
                  type: "text",
                  placeholder: "Type here",
                  modelValue: item.value.specify_others_option,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((item.value.specify_others_option) = $event))
                }, null, 8, ["modelValue"]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}
}

})